<template>
  <b-modal
    id="shetab-add-card-modal"
    content-class="shetab-add-to-card-modal-content"
    header-class="border-none"
    body-class="border-none p-0 px-2 pb-2 shetab-add-to-card-modal-body"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    v-model="modalVisibility"
  >
    <template #default>
      <b-container
        class="d-flex flex-column justify-content-center align-items-center main-container m-0 p-0 pb-3"
        fluid
      >
        <b-container class="second-container m-0 p-0 pb-4" fluid>
          <b-row class="d-flex justify-content-center">
            <!--            <b-col-->
            <!--              cols="12"-->
            <!--              class="d-flex justify-content-start align-items-center p-0 mt-2"-->
            <!--            >-->
            <!--              <b-row-->
            <!--                class="d-flex justify-content-start align-items-center fill-width"-->
            <!--              >-->
            <!--                <b-col-->
            <!--                  cols="2"-->
            <!--                  class="d-flex justify-content-end align-items-center p-0"-->
            <!--                >-->
            <!--                  <button-->
            <!--                    @click="closeModal"-->
            <!--                    class="background-transparent close-button border-none p-0 mr-2"-->
            <!--                  >-->
            <!--                    <svg-->
            <!--                      xmlns="http://www.w3.org/2000/svg"-->
            <!--                      width="40"-->
            <!--                      height="40"-->
            <!--                      viewBox="0 0 40 40"-->
            <!--                      fill="none"-->
            <!--                    >-->
            <!--                      <path-->
            <!--                        d="M8.48518 25.4558C13.1715 30.1421 20.7694 30.1421 25.4557 25.4558C30.142 20.7696 30.142 13.1716 25.4557 8.48528C20.7694 3.79899 13.1715 3.79899 8.48518 8.48528C3.79889 13.1716 3.79889 20.7696 8.48518 25.4558Z"-->
            <!--                        stroke="#A4A4A4"-->
            <!--                        stroke-width="2"-->
            <!--                      />-->
            <!--                      <path-->
            <!--                        d="M19.516 19.5161L16.9705 16.9705M16.9705 16.9705L14.4249 14.4249M16.9705 16.9705L19.516 14.4249M16.9705 16.9705L14.4249 19.5161"-->
            <!--                        stroke="#A4A4A4"-->
            <!--                        stroke-width="2"-->
            <!--                        stroke-linecap="round"-->
            <!--                      />-->
            <!--                    </svg>-->
            <!--                  </button>-->
            <!--                </b-col>-->
            <!--              </b-row>-->
            <!--            </b-col>-->
            <b-col cols="12" class="d-flex justify-content-center p-0 mt-3">
              <b-row class="fill-width d-flex justify-content-center">
                <b-col
                  class="custom-icon-col d-flex justify-content-center align-items-center rounded-circle icon-col p-1"
                >
                  <b-container
                    class="m-0 p-2 rounded-circle border-1px-white"
                    fluid
                  >
                    <b-img
                      :src="require('@/assets/images/shetab-add-cart-icon.png')"
                      class="fill-width"
                      fluid
                    />
                  </b-container>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              class="d-flex justify-content-center align-items-center p-0 mt-1"
            >
              <span class="new-title-color font-size-xl font-weight-bold">
                {{ $translate("approveUser") }}
              </span>
            </b-col>
            <b-col
              cols="12"
              class="d-flex justify-content-center align-items-center p-0 mt-2"
            >
              <span
                class="black-text font-size-medium direction-rtl text-center"
              >
                {{ $translate("creatingASafeSpaceForUserPayments") }}،
                <br />
                {{ $translate("twoCardNumbersThatBelongToYouIsNeeded") }}
                <br />
                {{ $translate("afterApprovingBySupporterYouCanUseTheService") }}
                <br />
                {{ $translate("approvingYourProfileWillTakeMaximum20Minutes") }}
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M1 10C0.999999 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 0.999999 1 5.02944 1 10Z"
                      stroke="#A4A4A4"
                      stroke-width="1.5"
                    />
                    <path
                      d="M9.82568 14.2387L9.82568 9.26932M9.82568 5.82898L9.82568 6.5935"
                      stroke="#A4A4A4"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
              </span>
            </b-col>
            <b-col
              cols="11"
              class="d-flex justify-content-center align-items-center p-0 px-1 mt-3"
              v-if="
                terminalVerificationInfo &&
                terminalVerificationInfo.verification_card_required
              "
            >
              <div
                class="d-flex justify-content-center align-items-center input-group p-0"
              >
                <transition
                  name="animate__fadeIn"
                  enter-active-class="animate__animated animate__fadeIn"
                  leave-active-class="animate__animated animate__fadeOut"
                  appear
                >
                  <div class="input-group-prepend" v-if="bankImageSource">
                    <span
                      class="input-group-text new-form-control fill-height p-0"
                    >
                      <img :src="bankImageSource" height="40" width="45" />
                    </span>
                  </div>
                </transition>
                <b-col
                  class="custom-input-col px-1"
                  v-for="(key, i) in creditCardInfo"
                  :key="i"
                >
                  <b-form-input
                    class="new-form-control py-2"
                    v-model="key.value"
                    :key="i"
                    :id="`card-input-key${i}`"
                    @paste="onCreditCardInfoPaste($event, 'creditCardInfo')"
                    @input="handleAutoFocus(i)"
                    pattern="\d*"
                    inputmode="numeric"
                    v-mask="'####'"
                  />
                </b-col>
              </div>
            </b-col>
            <transition
              name="animate__fadeIn"
              :duration="200"
              enter-active-class="animate__animated animate__fadeIn "
              leave-active-class="animate__animated animate__fadeOut "
              appear
            >
              <b-col
                cols="10"
                class="d-flex justify-content-end align-items-center pt-2 direction-ltr"
                v-if="
                  !creditCardNumberValidation &&
                  creditCardInfo[3].value.length >= 4
                "
              >
                <span class="light-red-text font-size-xs font-weight-bold">
                  {{ $translate("invalidCardNumber") }}
                </span>
              </b-col>
            </transition>
            <b-col
              cols="11"
              class="d-flex justify-content-center align-items-center p-0 px-1 mt-3"
              v-if="
                terminalVerificationInfo &&
                terminalVerificationInfo.verification_card_required
              "
            >
              <div
                class="d-flex justify-content-center align-items-center input-group p-0"
              >
                <transition
                  name="animate__fadeIn"
                  enter-active-class="animate__animated animate__fadeIn"
                  leave-active-class="animate__animated animate__fadeOut"
                  appear
                >
                  <div class="input-group-prepend" v-if="secondBankImageSource">
                    <span
                      class="input-group-text new-form-control fill-height p-0"
                    >
                      <img
                        :src="secondBankImageSource"
                        height="40"
                        width="45"
                      />
                    </span>
                  </div>
                </transition>
                <b-col
                  class="custom-input-col px-1"
                  v-for="(key, i) in secondCreditCardInfo"
                  :key="i"
                >
                  <b-form-input
                    class="new-form-control py-2"
                    v-model="key.value"
                    :key="i"
                    :id="`second-card-input-key${i}`"
                    @paste="
                      onCreditCardInfoPaste($event, 'secondCreditCardInfo')
                    "
                    @input="handleSecondCardAutoFocus(i)"
                    pattern="\d*"
                    inputmode="numeric"
                    v-mask="'####'"
                  />
                </b-col>
              </div>
            </b-col>
            <transition
              name="animate__fadeIn"
              :duration="200"
              enter-active-class="animate__animated animate__fadeIn "
              leave-active-class="animate__animated animate__fadeOut "
              appear
            >
              <b-col
                cols="10"
                class="d-flex justify-content-end align-items-center pt-2 direction-ltr"
                v-if="
                  !secondCreditCardNumberValidation &&
                  secondCreditCardInfo[3].value.length >= 4
                "
              >
                <span class="light-red-text font-size-xs font-weight-bold">
                  {{ $translate("invalidCardNumber") }}
                </span>
              </b-col>
            </transition>
            <!--            <b-col cols="12" class="d-flex justify-content-center mt-3">-->
            <!--              <b-row class="d-flex justify-content-center fill-width">-->
            <!--                <b-col-->
            <!--                  cols="4"-->
            <!--                  class="d-flex justify-content-center align-items-center"-->
            <!--                >-->
            <!--                  <span class="fill-width mx-1 gray-single-line"></span>-->
            <!--                </b-col>-->
            <!--                <b-col-->
            <!--                  cols="4"-->
            <!--                  class="d-flex justify-content-center p-0 direction-rtl"-->
            <!--                >-->
            <!--                  <b-row class="d-flex justify-content-center fill-width">-->
            <!--                    <b-col-->
            <!--                      cols="4"-->
            <!--                      class="d-flex justify-content-center align-items-center p-0"-->
            <!--                    >-->
            <!--                      <b-form-input-->
            <!--                        id="card-expire-date-month"-->
            <!--                        class="new-form-control py-2"-->
            <!--                        v-model="creditCardExpireDate.month"-->
            <!--                        @input="cardExpireDateAutoFocus"-->
            <!--                        pattern="\d*"-->
            <!--                        inputmode="numeric"-->
            <!--                        v-mask="'##'"-->
            <!--                        :state="creditCardMonthExpireValidation"-->
            <!--                      />-->
            <!--                    </b-col>-->
            <!--                    <b-col-->
            <!--                      cols="1"-->
            <!--                      class="d-flex justify-content-center align-items-center p-0"-->
            <!--                    >-->
            <!--                      <span-->
            <!--                        class="d-flex justify-content-center align-items-center new-subtext-color font-weight-bold mt-1"-->
            <!--                      >-->
            <!--                        /-->
            <!--                      </span>-->
            <!--                    </b-col>-->
            <!--                    <b-col-->
            <!--                      cols="4"-->
            <!--                      class="d-flex justify-content-center align-items-center p-0"-->
            <!--                    >-->
            <!--                      <b-form-input-->
            <!--                        id="card-expire-date-year"-->
            <!--                        class="new-form-control py-2"-->
            <!--                        v-model="creditCardExpireDate.year"-->
            <!--                        pattern="\d*"-->
            <!--                        inputmode="numeric"-->
            <!--                        v-mask="'##'"-->
            <!--                        :state="creditCardMonthExpireValidation"-->
            <!--                      />-->
            <!--                    </b-col>-->
            <!--                    <b-col-->
            <!--                      cols="3"-->
            <!--                      class="d-flex justify-content-center align-items-center p-0 new-subtext-color"-->
            <!--                    >-->
            <!--                      <span-->
            <!--                        class="d-flex flex-column justify-content-center align-items-center font-size-small"-->
            <!--                      >-->
            <!--                        <span> تاریخ </span>-->
            <!--                        <span> انقضا </span>-->
            <!--                      </span>-->
            <!--                    </b-col>-->
            <!--                  </b-row>-->
            <!--                </b-col>-->
            <!--                <b-col-->
            <!--                  cols="4"-->
            <!--                  class="d-flex justify-content-center align-items-center"-->
            <!--                >-->
            <!--                  <span class="fill-width mx-1 gray-single-line"></span>-->
            <!--                </b-col>-->
            <!--              </b-row>-->
            <!--            </b-col>-->
            <!--            <b-col-->
            <!--              cols="8"-->
            <!--              align-self="center"-->
            <!--              class="d-flex justify-content-center pt-3"-->
            <!--              v-if="-->
            <!--                terminalVerificationInfo &&-->
            <!--                terminalVerificationInfo.verification_national_id_required-->
            <!--              "-->
            <!--            >-->
            <!--              <b-form-input-->
            <!--                id="national-id-input"-->
            <!--                name="national-id-input"-->
            <!--                placeholder="کد ملی خود را وارد کنید"-->
            <!--                class="new-form-control fill-height mx-1 text-end py-2 text-center"-->
            <!--                pattern="\d*"-->
            <!--                inputmode="numeric"-->
            <!--                required-->
            <!--                v-model="nationalId"-->
            <!--                v-mask="'##########'"-->
            <!--                :state="nationalIdValidation"-->
            <!--              ></b-form-input>-->
            <!--            </b-col>-->
          </b-row>
        </b-container>
        <b-row class="fill-width">
          <b-col
            cols="12"
            class="d-flex justify-content-center align-items-center p-0 mt-4"
          >
            <b-row
              class="d-flex justify-content-center align-items-center fill-width"
            >
              <b-col
                cols="5"
                class="d-flex justify-content-center align-items-center p-0"
              >
                <button
                  class="submit-button"
                  @click="submitTerminalVerificationInfo()"
                >
                  {{ $translate("submitInformation") }}
                </button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import Common from "@/common";
import alertHelper from "@/helper/AlertHelper";

export default {
  name: "TerminalVerificationModal",
  props: {
    visibility: Boolean,
    terminalVerificationInfo: Object,
    terminalVerificationIsPending: Boolean,
  },
  data() {
    return {
      modalVisibility: this.visibility,
      // creditCardExpireDate: {
      //   month: "",
      //   year: "",
      // },
      creditCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      secondCreditCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      creditCardNumberValidation: false,
      secondCreditCardNumberValidation: false,
      bankImageSource: "",
      secondBankImageSource: "",
      nationalId: "",
      nationalIdValidation: false,
      userVerificationInterval: null,
    };
  },
  computed: {
    // creditCardMonthExpireValidation() {
    //   return (
    //     +this.creditCardExpireDate.month <= 12 &&
    //     this.creditCardExpireDate.month.length === 2 &&
    //     this.creditCardExpireDate.year.length === 2
    //   );
    // },
  },
  watch: {
    nationalId(value) {
      this.nationalIdValidation = value.length === 10;
    },
    creditCardInfo: {
      handler(val) {
        this.bankImageSource = Common.findBank(this.creditCardInfo).svgAddress;
        const enteredCardNum =
          val[0].value + val[1].value + val[2].value + val[3].value;
        //checking credit card number validation
        if (enteredCardNum.length <= 16 && enteredCardNum.length > 0) {
          this.creditCardNumberValidation =
            Common.validateCreditCardNumber(enteredCardNum);
        }
      },
      deep: true,
    },
    secondCreditCardInfo: {
      handler(val) {
        this.secondBankImageSource = Common.findBank(
          this.secondCreditCardInfo
        ).svgAddress;
        const enteredCardNum =
          val[0].value + val[1].value + val[2].value + val[3].value;
        //checking credit card number validation
        if (enteredCardNum.length <= 16 && enteredCardNum.length > 0) {
          this.secondCreditCardNumberValidation =
            Common.validateCreditCardNumber(enteredCardNum);
        }
      },
      deep: true,
    },
    visibility(value) {
      this.modalVisibility = value;
    },
    modalVisibility(value) {
      //if the user closes the modal with anything but the button
      if (!value) this.closeModal();
      else {
        // if the user refreshed the page, and the terminal was running,
        // we need to start the interval again
        if (this.terminalVerificationIsPending) {
          this.startVerificationChecker();
        }
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
      this.clearData();
    },
    getSavedCards() {
      this.$emit("getSavedCards");
    },
    clearCardNumber() {
      this.creditCardInfo.forEach((card) => {
        card.value = "";
      });
      this.secondCreditCardInfo.forEach((card) => {
        card.value = "";
      });
    },
    clearImageSource() {
      this.bankImageSource = "";
      this.secondBankImageSource = "";
    },
    clearData() {
      this.clearCardNumber();
      this.clearImageSource();
    },
    handleAutoFocus(index) {
      if (this.creditCardInfo[index].value.length === 4) {
        const nextIndex = index + 1;
        if (nextIndex < this.creditCardInfo.length) {
          this.$nextTick(() => {
            document.getElementById(`card-input-key${nextIndex}`).focus();
          });
          //  last input
        } else {
          const inputEl = document.getElementById(`second-card-input-key0`);
          if (inputEl) inputEl.focus();
        }
      }
    },
    handleSecondCardAutoFocus(index) {
      if (this.secondCreditCardInfo[index].value.length === 4) {
        const nextIndex = index + 1;
        if (nextIndex < this.secondCreditCardInfo.length) {
          this.$nextTick(() => {
            document
              .getElementById(`second-card-input-key${nextIndex}`)
              .focus();
          });
          //  last input
        } else {
          const nationalIdEl = document.getElementById(`national-id-input`);
          if (nationalIdEl) nationalIdEl.focus();
        }
      }
    },

    onCreditCardInfoPaste(evt, targetVariable) {
      Common.onInfoPaste.call(this, evt, targetVariable);
    },
    showVerificationPendingAlert() {
      alertHelper.loadingAlert(
        "احراز هویت شما در حال بررسی میباشد، لطفا صبور باشید (اگراین بررسی بیشتر از ۲۰ دقیقه زمان برد، لطفا با پشتیبانی تماس بگیرید)"
      );
    },
    startVerificationInterval() {
      this.userVerificationInterval = setInterval(
        this.getUserVerification,
        20000
      );
    },
    clearVerificationInterval() {
      clearInterval(this.userVerificationInterval);
    },
    // start the loading alert and the interval if the interval was not already running
    startVerificationChecker() {
      // if the interval was not already running, start
      if (!this.userVerificationInterval) {
        this.showVerificationPendingAlert();
        this.startVerificationInterval();
      }
    },
    getUserVerification() {
      const queryId = this.$route.query.id;
      //because it may cause some problems if queryId is used in this condition
      if (queryId) {
        this.$http.get(`payments/${queryId}/verification-info/`).then(
          (result) => {
            const resultData = result.body.data;
            if (resultData.pending && !resultData.verified_card) {
              // if the interval was not already running, start
              this.startVerificationChecker();
            }
            // if the user had a rejection reason and pending was false
            else if (
              !resultData.pending &&
              resultData.verification_rejection_reason?.length > 0 &&
              !resultData.verified_card
            ) {
              alertHelper.errorAlert(
                "",
                resultData.verification_rejection_reason
              );
              this.clearVerificationInterval();
            }
            // meaning that the verification has been completed
            else if (!resultData.pending && resultData.verified_card) {
              this.clearVerificationInterval();
              this.getSavedCards();
              this.closeModal();
              alertHelper.successAlert("", "احراز هویت شما با موفیقت انجام شد");
            }
          },
          (error) => {
            // alertHelper.apiErrorAlert("", error.body.message);
            console.log(error.body.message);
            this.clearVerificationInterval();
          }
        );
      }
    },
    // cardExpireDateAutoFocus() {
    //   if (this.creditCardExpireDate.month.length === 2) {
    //     document.getElementById(`card-expire-date-year`).focus();
    //   }
    // },
    areCardsNumbersEqual(card1, card2) {
      const cardNum1 =
        card1[0].value + card1[1].value + card1[2].value + card1[3].value;
      const cardNum2 =
        card2[0].value + card2[1].value + card2[2].value + card2[3].value;
      return cardNum1 === cardNum2;
    },

    submitTerminalVerificationInfo() {
      let dataToServer = {};
      if (this.terminalVerificationInfo.verification_card_required)
        if (
          !this.creditCardNumberValidation &&
          !this.secondCreditCardNumberValidation
        ) {
          alertHelper.errorAlert("", "شماره کارت را به درستی وارد کنید");
          return;
        }
      if (
        this.areCardsNumbersEqual(
          this.creditCardInfo,
          this.secondCreditCardInfo
        )
      ) {
        alertHelper.errorAlert("", "شماره کارت ها نمیتوانند یکسان باشند");
        return;
      }
      // adding the cards to the data server if the condition was true
      else {
        const card1 = this.creditCardInfo.map((card) => card.value).join("");
        const card2 = this.secondCreditCardInfo
          .map((card) => card.value)
          .join("");

        dataToServer = {
          card1: card1,
          card2: card2,
        };
      }

      // if (this.terminalVerificationInfo.verification_national_id_required)
      //   if (!this.nationalIdValidation) {
      //     alertHelper.errorAlert("", "کد ملی خود را به درستی وارد کنید");
      //     return;
      //   }
      // adding the national id to the data server if the condition was true
      // else
      // dataToServer = {
      //   ...dataToServer,
      //   national_id: this.nationalId,
      // };
      const queryId = this.$route.query.id;
      if (queryId) {
        alertHelper.loadingAlert();
        this.$http
          .post(`payments/${queryId}/verification-info`, dataToServer)
          .then(
            (result) => {
              alertHelper.successAlert("", result.body.message);
              // check the verification conditions
              this.getUserVerification();
            },
            (error) => {
              alertHelper.apiErrorAlert("", error.body.message);
            }
          );
      }
    },
  },
  destroyed() {
    this.clearVerificationInterval();
  },
  mounted() {},
};
</script>

<style scoped>
.custom-input-col {
  flex: 0 0 21%; /* This makes the custom column 16% the width of a standard column */
}
.main-container {
  border: 2px dashed white;
  position: relative;
  border-radius: 28px !important;
  -webkit-border-radius: 28px !important;
  -moz-border-radius: 28px !important;
  background: #eaeaea;
  box-shadow: 0px 10px 30px 0px rgba(240, 16, 16, 0.04);
}
.second-container {
  /*using this width because of the dashed border from the parent*/
  width: 104%;
  border-radius: 28px !important;
  -webkit-border-radius: 28px !important;
  -moz-border-radius: 28px !important;
  background: white;
}
.submit-button {
  width: 100%;
  height: 45px;
  border: none;
  border-radius: 10px;
  background: #72d762;
  color: white;
}
.icon-col {
  background-color: #72d762;
}
.border-1px-white {
  border: 2px solid white;
}
.custom-icon-col {
  flex: 0 0 12%;
}
.gray-single-line {
  height: 3px;
  background-color: var(--input-background);
}
</style>
